import React from "react";
import { AlertCircle } from "lucide-react";
import { cn } from "../lib/utils";
import { Alert, AlertDescription } from "./alert";

/** Destructive alert for a load/save error message; renders nothing when empty. */
export function ErrorAlert({ error, className }: { error?: string | null; className?: string }) {
  if (!error) return null;
  return (
    <Alert variant="destructive" className={cn("mb-6", className)}>
      <AlertCircle className="h-4 w-4" />
      <AlertDescription>{error}</AlertDescription>
    </Alert>
  );
}
